// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  body {
  font-family: 'Inter', sans-serif;
  background: linear-gradient(to bottom, #f8f9fa, #e9ecef);
  min-height: 100vh;
  margin: 0;
  padding: 0;
}

h1, h2, h3, h4, h5, h6, .table thead th {
  font-family: 'Montserrat', sans-serif;
}

.table-responsive {
  scrollbar-width: thin;
  scrollbar-color: #e01074 #f1f1f1;
}

.table-responsive::-webkit-scrollbar {
  width: 8px;
}

.table-responsive::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.table-responsive::-webkit-scrollbar-thumb {
  background: #e01074;
  border-radius: 4px;
}

.table-responsive::-webkit-scrollbar-thumb:hover {
  background: #c20a5e;
}

.image-card:hover {
  transform: translateY(-2px);
  transition: transform 0.2s ease-in-out;
}

.card-body {
  padding: 0.75rem;
}

.table th, .table td {
  vertical-align: middle;
}

.btn {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"EAAE;EACA,gCAAgC;EAChC,wDAAwD;EACxD,iBAAiB;EACjB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB","sourcesContent":["  body {\n  font-family: 'Inter', sans-serif;\n  background: linear-gradient(to bottom, #f8f9fa, #e9ecef);\n  min-height: 100vh;\n  margin: 0;\n  padding: 0;\n}\n\nh1, h2, h3, h4, h5, h6, .table thead th {\n  font-family: 'Montserrat', sans-serif;\n}\n\n.table-responsive {\n  scrollbar-width: thin;\n  scrollbar-color: #e01074 #f1f1f1;\n}\n\n.table-responsive::-webkit-scrollbar {\n  width: 8px;\n}\n\n.table-responsive::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.table-responsive::-webkit-scrollbar-thumb {\n  background: #e01074;\n  border-radius: 4px;\n}\n\n.table-responsive::-webkit-scrollbar-thumb:hover {\n  background: #c20a5e;\n}\n\n.image-card:hover {\n  transform: translateY(-2px);\n  transition: transform 0.2s ease-in-out;\n}\n\n.card-body {\n  padding: 0.75rem;\n}\n\n.table th, .table td {\n  vertical-align: middle;\n}\n\n.btn {\n  font-family: 'Inter', sans-serif;\n  font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
